import React from "react";
import "@/app/pages/companyProfile/financial/CompanyNewFinancialsStyles.scss";
import { formatData } from "@/shared/FunctionCore";

const Cashflow = ({ props }) => {
  return (
    <>
      <table className="mt">
        <thead>
          <th className="statement_name th" scope="col">
            Cash Flow (MIL)
          </th>
          {props.cashFlows.cashFlowYear.map((cashFlowYear) => (
            <>
              <th className="statement_year th" scope="col">
                {cashFlowYear}
              </th>
            </>
          ))}
        </thead>
        <tbody>
          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Net Operating Cash
            </th>
            {props.cashFlows.netOperatingCash.map((netOperatingCash) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(netOperatingCash)}
                </td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Net Investing Cash
            </th>
            {props.cashFlows.netInvestingCash.map((netInvestingCash) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(netInvestingCash)}
                </td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Net Financing Cash
            </th>
            {props.cashFlows.netFinancingCash.map((netFinancingCash) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(netFinancingCash)}
                </td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Net Change in Cash
            </th>
            {props.cashFlows.netChange.map((netChange) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(netChange)}
                </td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Cash at Beginning of Period
            </th>
            {props.cashFlows.cashAtBeginning.map((cashAtBeginning) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(cashAtBeginning)}
                </td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Cash at End of Period
            </th>
            {props.cashFlows.cashAtEnd.map((cashAtEnd) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(cashAtEnd)}
                </td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Capital Expenditure
            </th>
            {props.cashFlows.capitalExpenditure.map((capitalExpenditure) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(capitalExpenditure)}
                </td>
              </>
            ))}
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default Cashflow;
